import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
const IconAmountLower = (props) => {
    const id = useId();
    return (<IconWithGradient viewBox="0 0 24 24" id={id} width={24} height={24} defaultGradientKey="lightPink" {...props}>
      <Path d="M14.034 5.05062C14.7457 4.53692 15.7456 4.63628 16.3414 5.3064C16.9368 5.97677 16.9176 6.98091 16.3238 7.62738L16.1966 7.75188L10.8942 12.4656L16.0504 16.1318C16.8299 16.6863 17.0122 17.7679 16.4578 18.5475C15.9032 19.3266 14.8216 19.5091 14.0421 18.9548L8.5313 15.0369L8.38378 14.9246C6.9403 13.7665 6.82266 11.5998 8.13206 10.2921L8.2674 10.1649L13.8959 5.16159L14.034 5.05062Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
export default IconAmountLower;
